/**
 * Social accounts for the .person Foundation.
 *
 * Each entry has a `live: boolean` flag. When the account genuinely exists,
 * flip `live` to `true` and the icon will appear in the Footer and the URL
 * will be picked up by the Organization JSON-LD `sameAs` block.
 */

export type SocialId =
  | "github"
  | "x"
  | "bluesky"
  | "linkedin"
  | "mastodon"
  | "substack"
  | "youtube";

export interface SocialLink {
  id: SocialId;
  label: string;
  url: string;
  handle: string;
  live: boolean;
}

export const SOCIAL: SocialLink[] = [
  {
    id: "github",
    label: "GitHub",
    handle: "dotperson",
    url: "https://github.com/dotperson",
    live: false,
  },
  {
    id: "substack",
    label: "Substack",
    handle: "dotperson",
    url: "https://dotperson.substack.com",
    live: false,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    handle: "dotperson",
    url: "https://www.linkedin.com/company/dotperson",
    live: false,
  },
  {
    id: "x",
    label: "X",
    handle: "@dotperson",
    url: "https://x.com/dotperson",
    live: false,
  },
  {
    id: "bluesky",
    label: "Bluesky",
    handle: "dotperson.bsky.social",
    url: "https://bsky.app/profile/dotperson.bsky.social",
    live: false,
  },
  {
    id: "mastodon",
    label: "Mastodon",
    handle: "@dotperson@mastodon.social",
    url: "https://mastodon.social/@dotperson",
    live: false,
  },
  {
    id: "youtube",
    label: "YouTube",
    handle: "@dotperson",
    url: "https://www.youtube.com/@dotperson",
    live: false,
  },
];

export function liveSocial(): SocialLink[] {
  return SOCIAL.filter((s) => s.live);
}
